// import React, { useState, useRef, useEffect } from 'react';
// import JoditEditor from 'jodit-react';
// import './ProfilePage.css';
// import { FaBuilding, FaEdit, FaEnvelope, FaPhone, FaPlus } from 'react-icons/fa';
// import { TbWorldShare } from "react-icons/tb";
// import { useParams } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { selectUserExists } from '../redux/userSlice';
// import axios from 'axios';
// import { Base_Url } from '../config';
// import dummy from "../Assests/dummy.jpg";

// const ProfilePage = () => {
//     // State management
//     const [bioContent, setBioContent] = useState('');
//     const [cv, setCv] = useState('');
//     const [teachingResearch, setTeachingResearch] = useState('');
//     const [others, setOthers] = useState('');
//     const [academics, setAcademics] = useState('');
//     const [hasProfile, setHasProfile] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);
//     const [profileId, setProfileId] = useState(null);
//     const [scholarUserId, setScholarUserId] = useState(null);
//     const [facultyData, setFacultyData] = useState(null);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [activeSection, setActiveSection] = useState('bio');
//     const [currentContent, setCurrentContent] = useState('');

//     // Refs and Params
//     const editor = useRef(null);
//     const { id: facultyId } = useParams();

//     // Redux selectors
//     const userfromwebmaster = useSelector((state) => state.user);
//     const facultstaff = useSelector((state) => state.facultyuser);

//     const userExists = useSelector(selectUserExists);
//     const staffuser = useSelector((state) => state.staffuser)

//     console.log(staffuser, "this is staff data peopleprofile")
//     const statecsc = useSelector((state) => state.statecsc)


//     console.log(scholarUserId)
//     console.log(statecsc, "profilepage js userstate")
//     // Editor configuration
//     const editorConfig = {
//         readonly: false,
//         editHTMLDocumentMode: true,
//         uploader: {
//             url: `${Base_Url}/upload-image`,
//             filesVariableName: () => "image",
//             withCredentials: false,
//             format: "json",
//             method: "POST",
//             prepareData: (formData) => {
//                 const file = formData.get("image");
//                 formData.set("image", file);
//                 return formData;
//             },
//             isSuccess: (resp) => {
//                 if (resp.imageUrl) {
//                     const newContent = `${currentContent}<img src="${resp.imageUrl}" alt="Uploaded image" />`;
//                     updateSectionContent(newContent);
//                     return true;
//                 }
//                 return false;
//             },
//             getMessage: (resp) => resp.msgs ? resp.msgs.join("\n") : 'An error occurred',
//             process: (resp) => resp,
//         },
//     };

//     // Fetch profile data
//     const fetchProfile = async () => {
//         try {
//             const response = await axios.get(`${Base_Url}/profile/${facultyId}`);
//             if (response.data) {
//                 const data = response.data;
//                 setBioContent(data.bio || '');
//                 setCv(data.cv_and_specialization || '');
//                 setTeachingResearch(data.teaching_and_research || '');
//                 setOthers(data.others || '');
//                 setAcademics(data.academics || '');
//                 setProfileId(data.id);
//                 setHasProfile(true);
//                 setScholarUserId(data.userid);
//                 setFacultyData(data);
//             } else {
//                 setHasProfile(false);
//             }
//         } catch (error) {
//             console.error('Error fetching profile:', error);
//             setError('Failed to fetch profile data');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchProfile();
//     }, [facultyId]);


//     useEffect(() => {
//         // Update current content based on active section
//         switch (activeSection) {
//             case 'bio':
//                 setCurrentContent(bioContent);
//                 break;
//             case 'academics':
//                 setCurrentContent(academics);
//                 break;
//             case 'cv_and_specialization':
//                 setCurrentContent(cv);
//                 break;
//             case 'teaching_and_research':
//                 setCurrentContent(teachingResearch);
//                 break;
//             case 'others':
//                 setCurrentContent(others);
//                 break;
//             default:
//                 setCurrentContent('');
//         }
//     }, [activeSection, bioContent, academics, cv, teachingResearch, others]);

//     // Update section content
//     const updateSectionContent = (newContent) => {
//         switch (activeSection) {
//             case 'bio':
//                 setBioContent(newContent);
//                 break;
//             case 'academics':
//                 setAcademics(newContent);
//                 break;
//             case 'cv_and_specialization':
//                 setCv(newContent);
//                 break;
//             case 'teaching_and_research':
//                 setTeachingResearch(newContent);
//                 break;
//             case 'others':
//                 setOthers(newContent);
//                 break;
//         }
//         setCurrentContent(newContent);
//     };

//     // Event handlers
//     const handleEditorChange = (newContent) => {
//         updateSectionContent(newContent);
//     };

//     const saveBioContent = async () => {
//         try {
//             const url = hasProfile ? `${Base_Url}/profile/${profileId}` : `${Base_Url}/profile`;
//             const method = hasProfile ? 'PUT' : 'POST';
//             const userId = userfromwebmaster?.userData?.userid || facultstaff?.facultyprofileData?.user_id || "";

//             const body = {
//                 faculty_id: facultyId,
//                 bio: bioContent,
//                 academics: academics,
//                 cv_and_specialization: cv,
//                 teaching_and_research: teachingResearch,
//                 others: others,
//                 name: facultyData?.name,
//                 designation: facultyData?.title,
//                 research_areas: facultyData?.research_areas,
//                 email: facultyData?.email,
//                 office: facultyData?.office,
//                 phone: facultyData?.phone,
//                 weblink: facultyData?.weblink,
//                 study: facultyData?.study,
//                 ...(hasProfile ? { updated_by: userId } : { created_by: userId }),
//             };

//             const response = await axios({
//                 method,
//                 url,
//                 data: body,
//                 headers: { 'Content-Type': 'application/json' },
//             });

//             if (response.status === 200) {
//                 setHasProfile(true);
//                 if (response.data.id) {
//                     setProfileId(response.data.id);
//                 }
//                 setIsEditing(false);
//                 fetchProfile();
//             }
//         } catch (error) {
//             console.error('Error saving content:', error);
//             setError('Failed to save content. Please try again.');
//         }
//     };

//     const toggleEditing = () => setIsEditing(!isEditing);

//     // Loading and error states
//     if (isLoading) return <div className="loading">Loading...</div>;
//     if (error) return <div className="error">Error: {error}</div>;

//     const sections = [
//         { id: 'bio', label: 'Bio' },
//         { id: 'academics', label: 'Academics' },
//         { id: 'cv_and_specialization', label: 'CV & Specialization' },
//         { id: 'teaching_and_research', label: 'Teaching & Research' },
//         { id: 'others', label: 'Others' }
//     ];

//     // Render functions
//     const renderContactInfo = (icon, label, value) => {
//         if (!value || value.trim() === '') return null;

//         return (
//             <div className="contact-item">
//                 <div className="d-flex">
//                     {icon}
//                 </div>
//                 <p>
//                     <strong className="text-white">{label}:</strong>
//                     <span className="text-white">{value}</span>
//                 </p>
//             </div>
//         );
//     };



//     return (
//         <div className="profile-container">
//             <div className="profile-card">
//                 {facultyData && (
//                     <>
//                         <img
//                             src={facultyData?.image_path && facultyData.image_path !== ""
//                                 ? `${Base_Url}/${facultyData.image_path}`
//                                 : dummy}
//                             alt={facultyData.name}
//                             className="profile-image"
//                         />
//                         <h2 className="profile-name text-white">{facultyData.name}</h2>
//                         <p className="profile-title">{facultyData.study}</p>
//                         <div className="profile-contact">
//                             {renderContactInfo(<FaEnvelope />, "Email", facultyData.email)}
//                             {renderContactInfo(<FaPhone />, "Phone", facultyData.phone)}
//                             {renderContactInfo(<FaBuilding />, "Office", facultyData.office)}
//                             {renderContactInfo(<TbWorldShare />, "Website", facultyData.weblink)}
//                         </div>
//                     </>
//                 )}
//             </div>

//             <div className="profile-details">
//                 <div className="bio-section">
//                     <div className="section-header d-flex justify-content-between align-items-center">
//                         <div className="profile-navigation ms-2">
//                             {sections.map(section => {
//                                 let sectionContent = '';
//                                 switch (section.id) {
//                                     case 'bio':
//                                         sectionContent = bioContent;
//                                         break;
//                                     case 'academics':
//                                         sectionContent = academics;
//                                         break;
//                                     case 'cv_and_specialization':
//                                         sectionContent = cv;
//                                         break;
//                                     case 'teaching_and_research':
//                                         sectionContent = teachingResearch;
//                                         break;
//                                     case 'others':
//                                         sectionContent = others;
//                                         break;
//                                 }


//                                 console.log(sectionContent, "this is currentsection")
//                                 if (sectionContent || (statecsc.userState === 0 ||
//                                     ((statecsc.userState === 1 || statecsc.userState === 2) &&
//                                         (facultstaff?.facultyprofileData?.user_id === scholarUserId ||
//                                             staffuser?.staffData?.user_id === scholarUserId)))) {
//                                     return (
//                                         <button
//                                             key={section.id}
//                                             onClick={() => {
//                                                 setActiveSection(section.id);
//                                                 setIsEditing(false);
//                                             }}
//                                             className={`
//                                                 px-4 py-2 rounded-md font-medium transition-all duration-200
//                                                 ${activeSection === section.id
//                                                     ? 'bg-red-600 text-white shadow-md'
//                                                     : 'bg-white text-gray-700 text-dark hover:bg-red-50 border border-gray-200'
//                                                 }
//                                             `}
//                                         >
//                                             {section.label}
//                                         </button>
//                                     );
//                                 }
//                                 return null;
//                             })}
//                         </div>

//                         {
//                             (statecsc.userState === 0 ||
//                                 ((statecsc.userState === 1 || statecsc.userState === 2) &&
//                                     (facultstaff?.facultyprofileData?.user_id === scholarUserId ||
//                                         staffuser?.staffData?.user_id === scholarUserId))) && (
//                                 <div className="edit-controls">
//                                     {currentContent ? (
//                                         <FaEdit size={20} className="icon" onClick={toggleEditing} />
//                                     ) : (
//                                         <FaEdit size={20} className="icon add-icon" onClick={toggleEditing} />
//                                     )}
//                                 </div>
//                             )
//                         }

//                     </div>

//                     <div className="content-section p-3">
//                         {isEditing ? (
//                             <div className="editor-container">
//                                 <JoditEditor
//                                     ref={editor}
//                                     value={currentContent || ''}
//                                     config={editorConfig}
//                                     tabIndex={1}
//                                     onBlur={handleEditorChange}
//                                 />
//                                 <button
//                                     className="save-button"
//                                     onClick={saveBioContent}
//                                 >
//                                     {currentContent ? 'Update' : 'Save'}
//                                 </button>
//                             </div>
//                         ) : (
//                             currentContent ? (
//                                 <div
//                                     className="bio-content"
//                                     dangerouslySetInnerHTML={{ __html: currentContent }}
//                                 />
//                             ) : (
//                                 <div className="empty-state">
//                                     <p className="no-data-message">No Data Available</p>
//                                     {(statecsc.userState === 0 ||
//                                         ((statecsc.userState === 1 || statecsc.userState === 2) &&
//                                             (facultstaff?.facultyprofileData?.user_id === scholarUserId ||
//                                                 staffuser?.staffData?.user_id === scholarUserId))) && (
//                                             ""
//                                         )}
//                                 </div>
//                             )
//                         )}
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ProfilePage;



import React, { useState, useRef, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import './ProfilePage.css';
import { FaBuilding, FaEdit, FaEnvelope, FaPhone, FaPlus, FaTrash } from 'react-icons/fa';
import { TbWorldShare } from "react-icons/tb";
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserExists } from '../redux/userSlice';
import axios from 'axios';
import { Base_Url } from '../config';
import dummy from "../Assests/dummy.jpg";

const ProfilePage = () => {
    // State management
    const [bioContent, setBioContent] = useState('');
    const [cv, setCv] = useState('');
    const [teachingResearch, setTeachingResearch] = useState('');
    const [others, setOthers] = useState('');
    const [academics, setAcademics] = useState('');
    const [hasProfile, setHasProfile] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [profileId, setProfileId] = useState(null);
    const [scholarUserId, setScholarUserId] = useState(null);
    const [facultyData, setFacultyData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeSection, setActiveSection] = useState('bio');
    const [currentContent, setCurrentContent] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);

    // Refs and Params
    const editor = useRef(null);
    const { id: facultyId } = useParams();

    // Redux selectors
    const userfromwebmaster = useSelector((state) => state.user);
    const facultstaff = useSelector((state) => state.facultyuser);
    const userExists = useSelector(selectUserExists);
    const staffuser = useSelector((state) => state.staffuser);
    const statecsc = useSelector((state) => state.statecsc);

    // Helper function to check if content is effectively empty
    const isContentEmpty = (content) => {
        if (!content || typeof content !== 'string') return true;
        
        // Create a temporary DOM element to parse HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = content;
        
        // Get text content and trim whitespace
        const textContent = tempDiv.textContent || tempDiv.innerText || '';
        
        // Check if what remains is empty
        return textContent.trim() === '';
    };

    // Editor configuration
    const editorConfig = {
        readonly: false,
        editHTMLDocumentMode: true,
        uploader: {
            url: `${Base_Url}/upload-image`,
            filesVariableName: () => "image",
            withCredentials: false,
            format: "json",
            method: "POST",
            prepareData: (formData) => {
                const file = formData.get("image");
                formData.set("image", file);
                return formData;
            },
            isSuccess: (resp) => {
                if (resp.imageUrl) {
                    const newContent = `${currentContent}<img src="${resp.imageUrl}" alt="Uploaded image" />`;
                    updateSectionContent(newContent);
                    return true;
                }
                return false;
            },
            getMessage: (resp) => resp.msgs ? resp.msgs.join("\n") : 'An error occurred',
            process: (resp) => resp,
        },
    };

    // Fetch profile data
    const fetchProfile = async () => {
        try {
            const response = await axios.get(`${Base_Url}/profile/${facultyId}`);
            if (response.data) {
                const data = response.data;
                setBioContent(data.bio || '');
                setCv(data.cv_and_specialization || '');
                setTeachingResearch(data.teaching_and_research || '');
                setOthers(data.others || '');
                setAcademics(data.academics || '');
                setProfileId(data.id);
                setHasProfile(true);
                setScholarUserId(data.userid);
                setFacultyData(data);
            } else {
                setHasProfile(false);
            }
        } catch (error) {
            console.error('Error fetching profile:', error);
            setError('Failed to fetch profile data');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, [facultyId]);

    useEffect(() => {
        // Update current content based on active section
        switch (activeSection) {
            case 'bio':
                setCurrentContent(bioContent);
                break;
            case 'academics':
                setCurrentContent(academics);
                break;
            case 'cv_and_specialization':
                setCurrentContent(cv);
                break;
            case 'teaching_and_research':
                setCurrentContent(teachingResearch);
                break;
            case 'others':
                setCurrentContent(others);
                break;
            default:
                setCurrentContent('');
        }
    }, [activeSection, bioContent, academics, cv, teachingResearch, others]);

    // Update section content
    const updateSectionContent = (newContent) => {
        switch (activeSection) {
            case 'bio':
                setBioContent(newContent);
                break;
            case 'academics':
                setAcademics(newContent);
                break;
            case 'cv_and_specialization':
                setCv(newContent);
                break;
            case 'teaching_and_research':
                setTeachingResearch(newContent);
                break;
            case 'others':
                setOthers(newContent);
                break;
        }
        setCurrentContent(newContent);
    };

    // Delete section content
    const deleteSectionContent = async () => {
        if (!window.confirm('Are you sure you want to delete this section content?')) {
            return;
        }

        setIsDeleting(true);
        try {
            const updatedContent = {
                ...(hasProfile && { id: profileId }),
                faculty_id: facultyId,
                [activeSection]: '',
                updated_by: userfromwebmaster?.userData?.userid || facultstaff?.facultyprofileData?.user_id || ""
            };

            await axios.put(`${Base_Url}/profile/${profileId}`, updatedContent);
            fetchProfile();
            setIsEditing(false);
        } catch (error) {
            console.error('Error deleting content:', error);
            setError('Failed to delete content');
        } finally {
            setIsDeleting(false);
        }
    };

    // Event handlers
    const handleEditorChange = (newContent) => {
        updateSectionContent(newContent);
    };

    const saveBioContent = async () => {
        try {
            const url = hasProfile ? `${Base_Url}/profile/${profileId}` : `${Base_Url}/profile`;
            const method = hasProfile ? 'PUT' : 'POST';
            const userId = userfromwebmaster?.userData?.userid || facultstaff?.facultyprofileData?.user_id || "";

            const body = {
                faculty_id: facultyId,
                bio: bioContent,
                academics: academics,
                cv_and_specialization: cv,
                teaching_and_research: teachingResearch,
                others: others,
                name: facultyData?.name,
                designation: facultyData?.title,
                research_areas: facultyData?.research_areas,
                email: facultyData?.email,
                office: facultyData?.office,
                phone: facultyData?.phone,
                weblink: facultyData?.weblink,
                study: facultyData?.study,
                ...(hasProfile ? { updated_by: userId } : { created_by: userId }),
            };

            const response = await axios({
                method,
                url,
                data: body,
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.status === 200) {
                setHasProfile(true);
                if (response.data.id) {
                    setProfileId(response.data.id);
                }
                setIsEditing(false);
                fetchProfile();
            }
        } catch (error) {
            console.error('Error saving content:', error);
            setError('Failed to save content. Please try again.');
        }
    };

    const toggleEditing = () => setIsEditing(!isEditing);

    // Loading and error states
    if (isLoading) return <div className="loading">Loading...</div>;
    if (error) return <div className="error">Error: {error}</div>;

    const sections = [
        { id: 'bio', label: 'Bio' },
        { id: 'academics', label: 'Academics' },
        { id: 'cv_and_specialization', label: 'CV & Specialization' },
        { id: 'teaching_and_research', label: 'Teaching & Research' },
        { id: 'others', label: 'Others' }
    ];

    // Filter sections based on content and permissions
    const filteredSections = sections.filter(section => {
        // Check if section has non-empty content
        let hasContent = false;
        switch (section.id) {
            case 'bio':
                // Always show Bio section if profile exists
                return hasProfile;
            case 'academics':
                hasContent = !isContentEmpty(academics);
                break;
            case 'cv_and_specialization':
                hasContent = !isContentEmpty(cv);
                break;
            case 'teaching_and_research':
                hasContent = !isContentEmpty(teachingResearch);
                break;
            case 'others':
                hasContent = !isContentEmpty(others);
                break;
        }
        
        // Check if user has permission to edit
        const canEdit = 
            statecsc.userState === 0 ||
            ((statecsc.userState === 1 || statecsc.userState === 2) &&
            (facultstaff?.facultyprofileData?.user_id === scholarUserId ||
             staffuser?.staffData?.user_id === scholarUserId));
        
        // Show section if it has content OR if user can edit
        return hasContent || canEdit;
    });

    // Render functions
    const renderContactInfo = (icon, label, value) => {
        if (!value || value.trim() === '') return null;

        return (
            <div className="contact-item">
                <div className="d-flex">
                    {icon}
                </div>
                <p>
                    <strong className="text-white">{label}:</strong>
                    <span className="text-white">{value}</span>
                </p>
            </div>
        );
    };

    return (
        <div className="profile-container">
            <div className="profile-card">
                {facultyData && (
                    <>
                        <img
                            src={facultyData?.image_path && facultyData.image_path !== ""
                                ? `${Base_Url}/${facultyData.image_path}`
                                : dummy}
                            alt={facultyData.name}
                            className="profile-image"
                        />
                        <h2 className="profile-name text-white">{facultyData.name}</h2>
                        <p className="profile-title">{facultyData.study}</p>
                        <div className="profile-contact">
                            {renderContactInfo(<FaEnvelope />, "Email", facultyData.email)}
                            {renderContactInfo(<FaPhone />, "Phone", facultyData.phone)}
                            {renderContactInfo(<FaBuilding />, "Office", facultyData.office)}
                            {renderContactInfo(<TbWorldShare />, "Website", facultyData.weblink)}
                        </div>
                    </>
                )}
            </div>

            <div className="profile-details">
                <div className="bio-section">
                    <div className="section-header d-flex justify-content-between align-items-center">
                        <div className="profile-navigation ms-2">
                            {filteredSections.map(section => (
                                <button
                                    key={section.id}
                                    onClick={() => {
                                        setActiveSection(section.id);
                                        setIsEditing(false);
                                    }}
                                    className={`
                                        px-4 py-2 rounded-md font-medium transition-all duration-200
                                        ${activeSection === section.id
                                            ? 'bg-red-600 text-white shadow-md'
                                            : 'bg-white text-gray-700 text-dark hover:bg-red-50 border border-gray-200'
                                        }
                                    `}
                                >
                                    {section.label}
                                </button>
                            ))}
                        </div>

                        {(statecsc.userState === 0 ||
                            ((statecsc.userState === 1 || statecsc.userState === 2) &&
                                (facultstaff?.facultyprofileData?.user_id === scholarUserId ||
                                    staffuser?.staffData?.user_id === scholarUserId))) && (
                            <div className="edit-controls">
                                {!isContentEmpty(currentContent) ? (
                                    <>
                                        <button 
                                            className="edit-btn"
                                            onClick={toggleEditing}
                                            title="Edit this section"
                                        >
                                            <FaEdit size={16} />
                                        </button>
                                        <button 
                                            className="delete-btn"
                                            onClick={deleteSectionContent}
                                            title="Delete this section"
                                            disabled={isDeleting}
                                        >
                                            {isDeleting ? 'Deleting...' : <FaTrash size={16} />}
                                        </button>
                                    </>
                                ) : (
                                    <button 
                                        className="add-btn"
                                        onClick={toggleEditing}
                                        title="Add content to this section"
                                    >
                                        <FaPlus size={16} /> Add Content
                                    </button>
                                )}
                            </div>
                        )}
                      
                    </div>

                    <div className="content-section p-3">
                        {isEditing ? (
                            <div className="editor-container">
                                <JoditEditor
                                    ref={editor}
                                    value={currentContent || ''}
                                    config={editorConfig}
                                    tabIndex={1}
                                    onBlur={handleEditorChange}
                                />
                                <div className="editor-actions">
                                    <button
                                        className="save-button"
                                        onClick={saveBioContent}
                                    >
                                        {!isContentEmpty(currentContent) ? 'Update' : 'Save'}
                                    </button>
                                    <button
                                        className="cancel-button"
                                        onClick={toggleEditing}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        ) : (
                            !isContentEmpty(currentContent) ? (
                                <div
                                    className="bio-content"
                                    dangerouslySetInnerHTML={{ __html: currentContent }}
                                />
                            ) : (
                                <div className="empty-state">
                                    <p className="no-data-message">No Data Available</p>
                                    {(statecsc.userState === 0 ||
                                        ((statecsc.userState === 1 || statecsc.userState === 2) &&
                                            (facultstaff?.facultyprofileData?.user_id === scholarUserId ||
                                                staffuser?.staffData?.user_id === scholarUserId))) && (
                                        <button 
                                            className="add-content-btn"
                                            onClick={toggleEditing}
                                        >
                                            <FaPlus /> Add Content
                                        </button>
                                    )}
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;